import React from 'react'
import Fragment from '../common/fragment'


function FragmentAV(props) {
  return (
    <Fragment pos="v" {...props}>
      <p>
¿Habrá abejas en Salamanca? Miel eléctrica de los valles. Vuelo sinuoso de los
insectos. Un Muñeco gigante que espera el zumbido de las moscas y la muerte
milimétrica de las abejas. La Refinería guardará el secreto. Verá todo, pero no dirá
nada.
      </p>
    </Fragment>
  )
}


export default FragmentAV
